export default {
  format(type, context) {
    if (!context)
      context = 'piglet';

    if (type === 1) {
      return 'E';
    } else {
      return context === 'piglet'
        ? 'M'
        : 'A';
    }
  }
}
